commusoftCommon.filter('TimeDateFormatWithSec', function() {
    return function (dateString) {
        //check for diff zone uk for default +01:00
        return moment(dateString).format('Do MMM YYYY [at] HH:mm a')
    };
});